import { render, staticRenderFns } from "./AnimationText.vue?vue&type=template&id=6e39b6a0&scoped=true"
import script from "./AnimationText.vue?vue&type=script&lang=js"
export * from "./AnimationText.vue?vue&type=script&lang=js"
import style0 from "./AnimationText.vue?vue&type=style&index=0&id=6e39b6a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e39b6a0",
  null
  
)

export default component.exports